import { useRouter } from 'next/router'
import { IoClose } from 'react-icons/io5'
import isEmpty from 'lodash/isEmpty'
import { Box, Text } from '@chakra-ui/react'
import { MdCancel } from 'react-icons/md'

interface Props {
  itemKey: string
  itemValue: string
}

export const FilteredItem = ({ itemKey, itemValue }: Props) => {
  const router = useRouter()
  const { pathname, query } = router

  function handleClose() {
    const currentItem = (query[itemKey]! as string)
      .split(',')
      .filter((i) => i !== itemValue)
    delete query[itemKey]
    router.push({
      pathname,
      query: {
        ...query,
        ...(!isEmpty(currentItem) ? { [itemKey]: currentItem.join(',') } : {}),
      },
    })
  }
  return (
    <Text
      as="span"
      px="2"
      py="2"
      fontSize="12px"
      display="inline-flex"
      alignItems="center"
      borderRadius="4px"
      border="1px solid"
      borderColor="#D1D5DB"
      _hover={{ borderColor: 'brand', cursor: 'pointer' }}
      onClick={handleClose}
    >
      <Text>{itemValue}</Text>

      <Box as="span" ml="2" fontSize="14px" color="brand">
        <MdCancel />
      </Box>
    </Text>
  )
}
